export const appsRoutes = {
  basePath: '/app/apps',

  runPath: '/run',
  runAppCode: '/:appCode',
  runVersionCode: '/:appVersionCode',
};
